import React from "react";
import UploadUserModalComponent from "../../components/UserList/uploadUserModal";
import Sidebar from "../../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import * as profileActions from "../../redux/actions/profileAction";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as modalActions from "../../redux/actions/modalActions";
import { setLanguage } from "redux-i18n";
import * as commonActions from "../../redux/actions/commonAction";

export default function UserProfile(props, context) {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const in18Reducer = useSelector((state) => state.i18nState);

  const dispatch = useDispatch();
  let profileAction = bindActionCreators(profileActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);

  const resetFileHistory = () => {
      commonAction.resetFileHistory();
  }
  return (
    <>
    <div>
      <UploadUserModalComponent
        {...props}
        fileHistory={commonReducer.fileHistory}
        resetFileHistory={resetFileHistory}
        context={context}
        in18Reducer={in18Reducer}
      />
    </div>
    </>
  );
}
UserProfile.contextTypes = {
  t: PropTypes.func.isRequired,
};
